export function authRequest (state) {
  state.authStatus = 'loading';
}

export function authSuccess (state) {
  state.authStatus = 'success';
}

export function authError (state) {
  state.authStatus = 'error';
}
export function logout (state) {
  state.authStatus = '';
}

export function showLeftBar (state, value) {
  state.isShowLeftBar = value;
}

export function switchShowTree (state) {
  state.user.apps.TSZ.showTree = !state.user.apps.TSZ.showTree;
  state.isShowLeftBar = state.user.showTree;
}

export function setUser (state, value) {
  state.user = value;
  state.user.showTree = true;
}

export function setApp (state, value) {
  state.user.apps = state.user.apps || {};
}

export function setGroupList (state, value) {
  state.groupList = value;
}

export function setAppList (state, value) {
  state.appList = value;
}

export function showAppsButton (state, value) {
  state.isShowAppsButton = value;
}

export function showDetail (state, value) {
  state.showDetail = value;
}

export function setDatosTramos (state, value) {
  state.Presupuesto.Tramos = value;
}

export function setDatosDecision (state, value) {
  state.Presupuesto.DatosGenerales.ServicioId = value.ServicioId;
  state.Presupuesto.DatosGenerales.ActuacionId = value.ActuacionId;
  state.Presupuesto.DatosGenerales.ProblemaId = value.ProblemaId;
}

export function setDatosGenerales (state, value) {
  /*  state.Presupuesto.DatosGenerales.Usuario=value.Usuario;  */
  state.Presupuesto.DatosGenerales.Email = value.Email;
  state.Presupuesto.DatosGenerales.Aplicacion = value.Aplicacion;
  state.Presupuesto.DatosGenerales.Nombre = value.Nombre;
  state.Presupuesto.DatosGenerales.ProvinciaId = value.ProvinciaId;
  state.Presupuesto.DatosGenerales.MunicipioId = value.MunicipioId;
  state.Presupuesto.DatosGenerales.Tecnologia = value.Tecnologia;

  state.Presupuesto.DatosGenerales.NivelFreatico = value.NivelFreatico;
  state.Presupuesto.DatosGenerales.Trafico = value.Trafico;
  state.Presupuesto.DatosGenerales.MaterialId = value.MaterialId;
  state.Presupuesto.DatosGenerales.TerrenoId = value.TerrenoId;
  state.Presupuesto.DatosGenerales.PavimentoId = value.PavimentoId;
  state.Presupuesto.DatosGenerales.ProfundidadMedia = value.ProfundidadMedia;
  state.Presupuesto.DatosGenerales.Acometidas = value.Acometidas;
  state.Presupuesto.DatosGenerales.PozosRegistro = value.PozosRegistro;
  state.Presupuesto.DatosGenerales.Incidencias = value.Incidencias;
  state.Presupuesto.DatosGenerales.Id = value.Id;
}

export function setDatosComparativaBeneficio (state, value) {
  state.DatosComparativa.Beneficio = value;
}

export function setDatosComparativaCostes (state, value) {
  state.DatosComparativa.Costes = value;
}

export function setDatosComparativaTiempos (state, value) {
  state.DatosComparativa.Tiempos = value;
}

export function setOffline (state, value) {
  state.isOffline = value;
}

export function setHayDatos (state, value) {
  state.hayDatos = value;
}

export function setDatosListadoPresupuestos (state, value) {
  state.DatosListadoPresupuestos.Id = value.Id;
  state.DatosListadoPresupuestos.Fecha = value.Fecha;
  state.DatosListadoPresupuestos.Nombre = value.Nombre;
  state.DatosListadoPresupuestos.Provincia = value.Provincia;
  state.DatosListadoPresupuestos.Municipio = value.Municipio;
  state.DatosListadoPresupuestos.Estado = value.Estado;
  state.DatosListadoPresupuestos.Servicio = value.Servicio;
  state.DatosListadoPresupuestos.Tecnologia = value.Tecnologia;

  state.DatosListadoPresupuestos.CosteTcz = value.CosteTcz;
  state.DatosListadoPresupuestos.CosteTsz = value.CosteTsz;
  state.DatosListadoPresupuestos.BeneficioCoste = value.BeneficioCoste;
  state.DatosListadoPresupuestos.BeneficioTiempo = value.BeneficioTiempo;
  state.DatosListadoPresupuestos.BeneficioRuido = value.BeneficioRuido;
  state.DatosListadoPresupuestos.BeneficioCo2 = value.BeneficioCo2;
}

export function setDatosUsuario (state, value) {
  state.Usuario.user.mail = value.mail;
  state.Usuario.user.isExternal = value.isExternal;
  state.Usuario.user.appName = value.appName;
  state.Usuario.user.password = value.password;
  state.Usuario.user.id = value.id;
}

export function setDatosProfile (state, value) {
  state.Usuario.profile.nombre = value.nombre;
  state.Usuario.profile.apellidos = value.apellidos;
  state.Usuario.profile.empresa = value.empresa;
  state.Usuario.profile.telefono = value.telefono;
  state.Usuario.profile.id = value.id;

  state.Usuario.id = value.id;
}

export function setDatosGDPR (state, value) {
  state.Usuario.AceptaGdpr = value.AceptaGdpr;
  state.Usuario.AvisoComercial = value.AvisoComercial;
}

export function setDatosRegistroUsuario (state, value) {
  state.UsuarioRegistro.mail = value.mail;
  state.UsuarioRegistro.token = value.token;
}

export function setIdComparativa (state, value) {
  state.idComparativa = value;
}
